import { all, takeEvery, spawn } from 'redux-saga/effects'

import * as types from '../constants/ActionTypes'
import * as menuSagas from './menuSagas';
import * as sessionSagas from './sessionSagas';
import * as sendSagas from './sendSagas';


// Listens for and catches events that involve async requests
function* rootListener() {
    yield all([
        takeEvery(types.GET_ALL_CONVERSATIONS, menuSagas.getAllConversationsSaga),
        takeEvery(types.SWITCH_CONVERSATION, menuSagas.switchConversationSaga),
        takeEvery(types.GET_CONVERSATION_DETAILS, sessionSagas.getConversationDetailsSaga),
        takeEvery(types.LIMITED_LOGIN_REQUEST, sessionSagas.limitedLoginSaga),
        takeEvery(types.LIMITED_LOGIN_SEND_MESSAGE_REQUEST, sendSagas.limitedLoginSendMessageSaga),
        takeEvery(types.RESET_FORGOTTEN_PIN_REQUEST, sessionSagas.resetForgottenPINSaga),
        takeEvery(types.LOGIN_REQUEST, sessionSagas.loginSaga),
        takeEvery(types.LOGOUT_REQUEST, sessionSagas.logoutSaga),
        takeEvery(types.VERIFY_DOB_REQUEST, sessionSagas.verifyDOBSaga),
        takeEvery(types.VERIFY_NAME_REQUEST, sessionSagas.verifyNameSaga),
        takeEvery(types.SAVE_PIN_REQUEST, sessionSagas.savePINSaga),
        takeEvery(types.GET_ATTACHMENT, sendSagas.getAttachmentSaga),
        takeEvery(types.GET_MESSAGES, sendSagas.getMessagesSaga),
        takeEvery(types.REPLY_TO_CONVERSATION, sendSagas.replyToConversationSaga),
        takeEvery(types.SESSION_TIME_REQUEST, sessionSagas.getSessionTimeSaga),
    ]);
}

// Use call() after spawn() if necessary to invoke other actions.
export default function* appStart() {
    try {
        yield spawn(rootListener);
    } catch (error) {
        console.error("Error starting app", error);
    }
}